module.exports = "pegasus/assets/themelp1/small/32.png";